import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

/**
 * Contenedor de las páginas legales (Términos, Aviso de privacidad).
 * Ancho de lectura acotado (~70 caracteres por línea) y jerarquía clara.
 */
export default function LegalPage({ title, intro, updatedAt, children }) {
    return (
        <div data-testid="legal-page">
            <header className="bg-[#F6F6F3] border-b border-zinc-200">
                <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-1.5 text-sm font-medium text-[#4A4A4A] hover:text-primary transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 rounded-md"
                    >
                        <ArrowLeft className="w-4 h-4" aria-hidden="true" />
                        Volver al inicio
                    </Link>
                    <h1 className="mt-6 text-4xl sm:text-5xl font-extrabold tracking-[-0.03em] leading-[1.05] text-[#1A1A1A] text-balance">
                        {title}
                    </h1>
                    {intro && (
                        <p className="mt-5 text-lg text-[#4A4A4A] leading-relaxed">
                            {intro}
                        </p>
                    )}
                    <p className="mt-6 text-sm text-[#6B6B6B]">
                        Última actualización: {updatedAt}
                    </p>
                </div>
            </header>

            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
                {children}
            </div>
        </div>
    );
}

export function Section({ n, title, children }) {
    const id = `s-${n}`;
    return (
        <section id={id} className="scroll-mt-24 mb-12 last:mb-0">
            <h2 className="text-2xl font-bold tracking-[-0.02em] text-[#1A1A1A]">
                <span className="text-primary tabular-nums">{n}.</span> {title}
            </h2>
            <div className="mt-4 space-y-4">{children}</div>
        </section>
    );
}

export function P({ children }) {
    return (
        <p className="text-[16px] text-[#4A4A4A] leading-[1.7]">{children}</p>
    );
}

export function UL({ items }) {
    return (
        <ul className="space-y-2.5">
            {items.map((item, i) => (
                <li
                    key={i}
                    className="flex gap-3 text-[16px] text-[#4A4A4A] leading-[1.7]"
                >
                    <span
                        aria-hidden="true"
                        className="w-1.5 h-1.5 rounded-full bg-primary shrink-0 mt-3"
                    />
                    <span>{item}</span>
                </li>
            ))}
        </ul>
    );
}
